import React from 'react'
import classNames from 'classnames'
import { Media as MediaType } from '@/payload-types'
import { Avatar } from '@/ui/atoms/Avatar'

type ProfileProps = {
  size: 'mini' | 'medium' | 'big'
  className?: string
  appearance?: 'default' | 'inverted'
  image?: MediaType | string | null
  name?: string
  mail?: string
}

export const Profile: React.FC<ProfileProps> = ({
  className: classNameFromProps,
  size = 'medium',
  appearance = 'default',
  image,
  name,
  mail,
}) => {
  return (
    <div
      className={classNames(classNameFromProps, 'flex flex-row gap-2 justify-start items-center')}
    >
      {image && <Avatar variant={'circle'} userImage={image} size={size} />}
      <div>
        <p
          className={classNames('text-label-XS-semibold', mail ? 'mb-0.5' : 'mb-0', {
            'text-text-subtle-inverted': appearance === 'inverted',
            'text-text-subtle': appearance === 'default',
          })}
        >
          {name}
        </p>
        <p
          className={classNames('text-label-XS-regular mb-0', {
            'text-text-faded-inverted': appearance === 'inverted',
            'text-text-faded': appearance === 'default',
          })}
        >
          {mail}
        </p>
      </div>
    </div>
  )
}
